module.exports = __webpack_public_path__ + "img/icon-cancel.822d81e2.png";